module.exports = __webpack_public_path__ + "static/media/Casino-banner.16e8e6ef.png";